/**
 * 企画連絡承認画面　企画連絡承認VOクラス
 */
export class ApprovalItemModel {

    public orderCode: string = null
    public pCode: string = null
    public coopInformation: Array<any> = new Array<any>();
    public approvalColumnList: Array<any> = new Array<any>();
    public editorSelect: string = null
    public buyerSelect: string = null

}
